<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="
              () =>
                $router.push({
                  name: 'gestoesDeAulas',
                })
            "
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Plano Mensal
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="gestaoDeAula">
        <v-card color="green lighten-1" outlined>
          <v-col cols="10">
            <v-card-text>
              <h4>Turma: {{ gestaoDeAula.turma?.descricao }}</h4>
              <h4>
                Componente Curricular:
                {{
                  gestaoDeAula.is_polivalencia === 1
                    ? gestaoDeAula.disciplina
                    : gestaoDeAula.disciplina.descricao
                }}
              </h4>
              <h4>
                Professor:
                {{ gestaoDeAula.professor ? gestaoDeAula.professor.nome : "[carregando...]" }}
              </h4>
            </v-card-text>
          </v-col>
          <v-col cols="2">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  x-small
                  class="ml-1 white--text"
                  color="blue"
                  v-bind="attrs"
                  v-on="on"
                  @click="() => verHistoricoPlanos()"
                >
                  <span>Histórico do lancamento de planos</span>
                </v-btn>
              </template>
            </v-tooltip>
          </v-col>
        </v-card>
      </v-col>
      <v-col cols="12 text-center" class="pt-2">
        <template>
          <v-toolbar>
            <v-tabs dark v-model="form.mes_id" background-color="primary" grow>
              <v-tab
                v-for="item of $constants.mesesPlanoMensal"
                :key="item.id"
                @click="() => editarPlano(item.id)"
              >
                <v-badge v-if="form.mes_id === item.id" color="success">
                  {{ item.descricao }}
                </v-badge>
                <div v-else>{{ item.descricao }}</div>
              </v-tab>
            </v-tabs>
          </v-toolbar>
        </template>
      </v-col>
    </v-row>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form
        @submit.prevent="handleSubmit(createOrUpdate)"
        v-if="loadPlano"
        :disabled="submittingForm"
      >
        <v-row>
          <!-- <v-col cols="12">
            <ValidationProvider name="Tematica" rules="required" v-slot="{ errors }">
              <e-label>UNIDADES TEMÁTICAS</e-label>
              <v-textarea solo dense v-model="form.tematica" :error-messages="errors" />
            </ValidationProvider>
          </v-col> -->
          <v-col cols="12">
            <ValidationProvider name="Objetos do Conhecimento" rules="required" v-slot="{ errors }">
              <e-label>OBJETOS DO CONHECIMENTO</e-label>
              <v-textarea solo dense v-model="form.objeto_conhecimento" :error-messages="errors" />
            </ValidationProvider>
          </v-col>
          <v-col cols="12">
            <ValidationProvider name="Habilidades" rules="required" v-slot="{ errors }">
              <e-label>HABILIDADES/OBJETIVOS</e-label>
              <v-textarea solo dense v-model="form.habilidades" :error-messages="errors" />
            </ValidationProvider>
          </v-col>
          <!-- <v-col cols="12">
            <ValidationProvider name="Obervacoes" rules="required" v-slot="{ errors }">
              <e-label>OBSERVAÇÕES</e-label>
              <v-textarea solo dense v-model="form.observacoes" :error-messages="errors" />
            </ValidationProvider>
          </v-col> -->
          <v-col cols="12" class="mb-5">
            <ValidationProvider
              name="Metodologia"
              :rules="{ required: true, minArray: 1 }"
              v-slot="{ errors }"
            >
              <e-label>METODOLOGIAS/ESTRATÉGIAS</e-label>

              <v-row>
                <v-col
                  v-for="(item, index) in $constants.METODOLOGIAS_PLANOS_MENSAIS"
                  :key="index"
                  cols="12"
                  sm="4"
                  md="2"
                >
                  <v-checkbox
                    :label="item"
                    :value="item"
                    v-model="form.metodologia"
                    dense
                    multiple
                  ></v-checkbox>
                </v-col>
              </v-row>
              <div v-if="(form.metodologia || []).includes('Outros')">
                <v-label>OUTROS: </v-label>
                <ValidationProvider name="Metodologias outros" rules="required" v-slot="{ errors }">
                  <v-textarea
                    v-model="form.metodologia_outros"
                    label="Especifique outros métodos"
                    solo
                    dense
                    :error-messages="errors"
                  ></v-textarea>
                </ValidationProvider>
              </div>

              <span class="text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </v-col>

          <v-col cols="12" class="mb-5">
            <ValidationProvider
              name="Recursos Didáticos"
              :rules="{ required: true, minArray: 1 }"
              v-slot="{ errors }"
            >
              <e-label>RECURSOS DIDÁTICOS</e-label>

              <v-row>
                <v-col
                  v-for="(item, index) in $constants.RECURSOS_DIDATICOS_PLANOS_MENSAIS"
                  :key="index"
                  cols="12"
                  sm="4"
                  md="2"
                >
                  <v-checkbox
                    :label="item"
                    :value="item"
                    v-model="form.recursos_didaticos"
                    dense
                    multiple
                  ></v-checkbox>
                </v-col>
              </v-row>
              <div v-if="(form.recursos_didaticos || []).includes('Outros')">
                <v-label>OUTROS: </v-label>
                <ValidationProvider
                  name="Recursos didáticos outros"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-textarea
                    v-model="form.recursos_didaticos_outros"
                    label="Especifique outros métodos"
                    solo
                    dense
                    :error-messages="errors"
                  ></v-textarea>
                </ValidationProvider>
              </div>

              <span class="text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </v-col>
          <v-col cols="12" class="mb-5">
            <ValidationProvider
              name="Atividades Avaliativas"
              :rules="{ required: true, minArray: 1 }"
              v-slot="{ errors }"
            >
              <e-label>ATIVIDADES AVALIATIVAS</e-label>

              <v-row>
                <v-col
                  v-for="(item, index) in $constants.ATIVIDADES_AVALIATIVAS_PLANOS_MENSAIS"
                  :key="index"
                  cols="12"
                  sm="4"
                  md="2"
                >
                  <v-checkbox
                    :label="item"
                    :value="item"
                    v-model="form.avaliacao_aprendizagem"
                    dense
                    multiple
                  ></v-checkbox>
                </v-col>
              </v-row>
              <div v-if="(form.avaliacao_aprendizagem || []).includes('Outros')">
                <v-label>OUTROS: </v-label>
                <ValidationProvider
                  name="Atividades avaliativas outros"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-textarea
                    v-model="form.avaliacao_aprendizagem_outros"
                    label="Especifique outros atividades"
                    solo
                    dense
                    :error-messages="errors"
                  ></v-textarea>
                </ValidationProvider>
              </div>

              <span class="text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </v-col>
          <!-- <v-col cols="12">
            <ValidationProvider name="Referencia" rules="required" v-slot="{ errors }">
              <e-label>REFERÊNCIAS</e-label>
              <v-textarea solo dense v-model="form.referencias" :error-messages="errors" />
            </ValidationProvider>
          </v-col> -->
        </v-row>
        <v-col cols="12">
          <v-row>
            <v-btn
              color="primary"
              :disabled="submittingForm"
              :loading="submittingForm"
              type="submit"
              >Enviar Dados</v-btn
            >
          </v-row>
        </v-col>
      </form>
    </ValidationObserver>
    <e-drawer-planos-lancados
      v-model="openDrawer"
      :gestao_id="parseInt($route.params.gestaoDeAulaId, 10)"
      :mes_id="parseInt(form.mes_id, 10)"
      :disciplina_id="parseInt(form.disciplina_id, 10)"
    />
  </main-template>
</template>

<script>
import ELabel from "../../components/ELabel.vue";

export default {
  components: { ELabel },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
    gestaoDeAulaId: {
      type: [String, Number],
      require: true,
    },
  },
  mounted() {
    this.loadData();
  },
  data() {
    return {
      submittingForm: false,
      form: {
        mes_id: 0,
        disciplina_id: 0,
        metodologia: [],
        metodologia_outros: "",
        recursos_didaticos: [],
        recursos_didaticos_outros: "",
        avaliacao_aprendizagem: [],
        avaliacao_aprendizagem_outros: "",
      },
      openDrawer: false,
      gestaoDeAula: {
        turma: {
          descricao: "",
        },
        disciplina: {
          descricao: "",
        },
        disciplinas: [],
      },
      loadPlano: true,
    };
  },
  methods: {
    async verHistoricoPlanos() {
      this.openDrawer = !this.openDrawer;
    },
    async editarPlano(mes_id) {
      this.loadPlano = false;
      this.$loaderService.open("Carregando dados...");
      try {
        const { gestaoDeAulaId } = this.$route.params;
        this.form.instrutorDisciplinaTurma_id = gestaoDeAulaId;
        this.form.disciplina_id = this.disciplinaId;
        await this.$services.planosMensaisService.createOrUpdate(this.form);
        const response = await this.$services.planosMensaisService.planoMensal(
          gestaoDeAulaId,
          mes_id,
          this.disciplinaId
        );
        if (response !== "") {
          this.form = response;
          this.loadPlano = true;
          this.$loaderService.close();
          return;
        }
        this.form = {
          mes_id,
        };
      } catch (error) {
        this.$handleError(error);
      }
      this.loadPlano = true;
      this.$loaderService.close();
    },
    async createOrUpdate() {
      this.$loaderService.open("Carregando dados...");
      try {
        const { gestaoDeAulaId } = this.$route.params;
        const { mes_id } = this.form;
        this.form.mes_id = mes_id;
        this.form.instrutorDisciplinaTurma_id = gestaoDeAulaId;
        this.form.disciplina_id = this.disciplinaId;
        if (Array.isArray(this.form.metodologia)) {
          this.form.metodologia = JSON.stringify(this.form.metodologia);
        }
        if (Array.isArray(this.form.recursos_didaticos)) {
          this.form.recursos_didaticos = JSON.stringify(this.form.recursos_didaticos);
        }
        if (Array.isArray(this.form.avaliacao_aprendizagem)) {
          this.form.avaliacao_aprendizagem = JSON.stringify(this.form.avaliacao_aprendizagem);
        }

        await this.$services.planosMensaisService.createOrUpdate(this.form);
        this.$toast.success("Plano mensal salvo com sucesso!");
        await this.loadData();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async loadData() {
      const { gestaoDeAulaId } = this.$route.params;
      this.disciplinaId = parseInt(this.$route.params.disciplinaId, 10);
      const { meses } = this.form;

      try {
        this.$loaderService.open("Carregando dados...");
        this.gestaoDeAula = await this.$services.gestoesDeAulasService.visualizar(gestaoDeAulaId);

        const response = await this.$services.planosMensaisService.planoMensal(
          gestaoDeAulaId,
          meses,
          this.disciplinaId
        );

        if (this.gestaoDeAula.disciplinas.length > 0) {
          const disciplina = this.gestaoDeAula.disciplinas.filter((i) => {
            return i.id === this.disciplinaId;
          });

          this.gestaoDeAula.disciplina = disciplina[0].descricao;
        }

        if (response !== "") {
          this.form = response;

          if (this.form.metodologia && typeof this.form.metodologia === "string") {
            this.form.metodologia = JSON.parse(this.form.metodologia);
          }
          if (this.form.recursos_didaticos && typeof this.form.recursos_didaticos === "string") {
            this.form.recursos_didaticos = JSON.parse(this.form.recursos_didaticos);
          }

          if (
            this.form.avaliacao_aprendizagem &&
            typeof this.form.avaliacao_aprendizagem === "string"
          ) {
            this.form.avaliacao_aprendizagem = JSON.parse(this.form.avaliacao_aprendizagem);
          }
        }
        this.$emit("dialogChange", !this.dialog);
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
  },
};
</script>

<style>
.text-danger {
  color: #dc3545;
}
</style>
